import { CommonSearchParam, ApiBind } from './common-search-param.model';
import { Carrier } from '../constants';

export class DeviceModelSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
    value?: string,
    carrier?: Carrier,
    from?: Date,
    to?: Date,
  ) {
    super();
    this.name = name;
    this.value = value;
    this.carrier = carrier;
    this.sellDateFrom = from;
    this.sellDateTo = to;
  }

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'value' })
  value: string;

  @ApiBind({ column: 'carrier' })
  carrier: Carrier;

  @ApiBind({ column: 'sell_date_from' })
  sellDateFrom: Date;

  @ApiBind({ column: 'sell_date_to' })
  sellDateTo: Date;
}
